import { GenIcon } from '../helpers/IconBase.es.js';

const AccountColored = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 40 40", fill: "none" },
    child: [
      {
        tag: "rect",
        attr: { width: "40", height: "40", rx: "20", fill: "#F3F3F7" }
      },
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.7832 16.3636C14.7832 19.2451 17.1187 21.5806 20.0002 21.5806C22.8817 21.5806 25.2187 19.2451 25.2187 16.3636V13.7551C25.2187 10.8736 22.8817 8.53809 20.0002 8.53809C17.1187 8.53809 14.7832 10.8736 14.7832 13.7551V16.3636ZM12.8431 24.5639L17.0356 22.1579C17.0356 22.1579 18.2716 23.0804 20.0011 23.0804C21.7291 23.0804 22.9606 22.1609 22.9606 22.1609L27.1591 24.5639C28.3786 25.2584 29.1301 26.5574 29.1301 27.9614V28.9334C29.1301 28.9334 26.8621 32.0189 20.0011 32.0189C13.1401 32.0189 10.8706 28.9334 10.8706 28.9334V27.9614C10.8706 26.5574 11.6236 25.2584 12.8431 24.5639Z",
          fill: "#DCDEE9"
        }
      }
    ]
  })(props);
};

export { AccountColored };
